import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { Box } from "components/common"
import fetchSizeChart from "hoc/info/fetch-size-chart"

const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`

const ChartTableData = styled(Box).attrs((props) => ({
  as: "tr",
  ...props,
}))`
  text-align: center;
  :nth-child(even) {
    background-color: ${(props) => props.theme.colors.grey[5]};
  }
`

const Td = styled(Box).attrs({
  as: "td",
})`
  width: 33%;
  height: 45px;
`

const DiameterSizeChart = ({ sizeChart }) => (
  <Box contain>
    <Box>
      <Table>
        <thead>
          <ChartTableData mb={1}>
            <Td>RING SIZE</Td>
            <Td>DIAMETER</Td>
          </ChartTableData>
        </thead>
        <tbody>
          {sizeChart.map((size, i) => (
            <ChartTableData border key={`size${i}`}>
              <Td>{size.size}</Td>
              <Td>
                {size.diameter}
                <small>mm</small>
              </Td>
            </ChartTableData>
          ))}
        </tbody>
      </Table>
    </Box>
  </Box>
)
DiameterSizeChart.propTypes = {
  sizeChart: PropTypes.array,
}

export default fetchSizeChart(DiameterSizeChart)
